export const CREATE_TIPO_USUARIO_REQUEST = 'CREATE_TIPO_USUARIO_REQUEST';
export const CREATE_TIPO_USUARIO_SUCCESS = 'CREATE_TIPO_USUARIO_SUCCESS';
export const CREATE_TIPO_USUARIO_FAILURE = 'CREATE_TIPO_USUARIO_FAILURE';

export const FETCH_TIPOS_USUARIOS_REQUEST = 'FETCH_TIPOS_USUARIOS_REQUEST';
export const FETCH_TIPOS_USUARIOS_SUCCESS = 'FETCH_TIPOS_USUARIOS_SUCCESS';
export const FETCH_TIPOS_USUARIOS_FAILURE = 'FETCH_TIPOS_USUARIOS_FAILURE';

export const FETCH_TIPO_USUARIO_REQUEST = 'FETCH_TIPO_USUARIO_REQUEST';
export const FETCH_TIPO_USUARIO_SUCCESS = 'FETCH_TIPO_USUARIO_SUCCESS';
export const FETCH_TIPO_USUARIO_FAILURE = 'FETCH_TIPO_USUARIO_FAILURE';

export const UPDATE_TIPO_USUARIO_REQUEST = 'UPDATE_TIPO_USUARIO_REQUEST';
export const UPDATE_TIPO_USUARIO_SUCCESS = 'UPDATE_TIPO_USUARIO_SUCCESS';
export const UPDATE_TIPO_USUARIO_FAILURE = 'UPDATE_TIPO_USUARIO_FAILURE';

export const DELETE_TIPO_USUARIO_REQUEST = 'DELETE_TIPO_USUARIO_REQUEST';
export const DELETE_TIPO_USUARIO_SUCCESS = 'DELETE_TIPO_USUARIO_SUCCESS';
export const DELETE_TIPO_USUARIO_FAILURE = 'DELETE_TIPO_USUARIO_FAILURE';

export const SET_TIPOS_USUARIOS_PAGE = 'SET_TIPOS_USUARIOS_PAGE';
export const SET_TIPOS_USUARIOS_LIMIT = 'SET_TIPOS_USUARIOS_LIMIT';